import styled from "styled-components";
import { DESKTOP_MEDIA_QUERY } from "../constants";
import images from "../images";

const windowWidth =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

export const Wrapper = styled.div``;

export const Top = styled.div`
  background-color: #0000ff;
  background-image: url(${images.stamp.src});
  background-size: 192px;
  background-position: ${windowWidth - 180}px -27px;
  background-repeat: no-repeat;
  overflow: hidden;

  ${DESKTOP_MEDIA_QUERY} {
    background-size: 590px;
    background-position: center -165px;
  }
`;
export const TopInner = styled.div`
  max-width: 1027px;
  margin: 0 auto;
  padding: 0 30px;
`;

export const Score = styled.div`
  width: 127px;
  height: 122px;
  margin: 22px 27px;
  border: 3px solid #fff;
  text-align: center;
  color: #fff;

  ${DESKTOP_MEDIA_QUERY} {
    width: 270px;
    height: 240px;
    margin-top: 70px;
  }
`;

export const ScoreTop = styled.div`
  font-size: 72px;
  font-weight: 600;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 144px;
  }
`;

export const ScoreBottom = styled.div`
  font-size: 24px;
  font-weight: 100;
  margin-top: -10px;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 48px;
    margin-top: -20px;
  }
`;

export const ResultTitle = styled.div`
  margin-top: 40px;
  padding: 0 27px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 72px;
    margin-top: 30px;
  }
`;

export const ResultDescription = styled.div`
  margin-top: 20px;
  padding: 0 27px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 36px;
    margin-top: 10px;
  }
`;

export const Additional = styled.div`
  margin: 46px 0;
  padding-left: 130px;
  padding-right: 20px;
  background-image: url(${images.instructions_1.src});
  background-repeat: no-repeat;
  background-size: 32px;
  background-position: 90px center;
  display: flex;
  align-items: center;
  min-height: 45px;

  a {
    color: #fff;
  }

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 36px;
    min-height: 85px;

    background-size: 50px;
    background-position: 70px center;
  }
`;

export const ShareWrapper = styled.div`
  padding: 2px 34px;

  ${DESKTOP_MEDIA_QUERY} {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }
`;

export const ShareRight = styled.div`
  ${DESKTOP_MEDIA_QUERY} {
    order: 2;
  }
`;

export const ShareLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #0000ff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 24px;
  }
`;

export const ShareButtonsWrapper = styled.div`
  display: flex;
  margin-top: 5px;
`;

export const ShareButton = styled.div`
  width: 35px;
  height: 35px;
  margin-right: 10px;
  background-image: url(${({ k }) => images[k].src});
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;

  ${DESKTOP_MEDIA_QUERY} {
    width: 63px;
    height: 63px;
  }
`;

export const Button = styled.a`
  display: block;
  width: 230px;
  height: 42px;
  margin: 22px auto 0;
  font-size: 18px;
  font-weight: bold;
  background-color: #0000ff;
  color: #fff;
  text-align: center;
  line-height: 42px;
  border-radius: 21px;
  cursor: pointer;

  ${DESKTOP_MEDIA_QUERY} {
    width: 508px;
    height: 90px;
    margin: 0;
    font-size: 36px;
    line-height: 90px;
    border-radius: 45px;
  }
`;

export const GameoverWrapper = styled.div`
  padding: 21px 23px;
`;

export const GameoverTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #0000ff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 48px;
  }
`;

export const GameoverPic = styled.div`
  width: 100%;
  height: 300px;
  margin-top: 15px;
  background-image: url(${images.gameover_pic.src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  ${DESKTOP_MEDIA_QUERY} {
    height: 470px;
    margin-bottom: 0px;
    background-image: url(${images.gameover_pic_d.src});
  }
`;

export const LoseText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #0000ff;
  text-align: center;

  ${DESKTOP_MEDIA_QUERY} {
    margin-top: -50px;
    font-size: 48px;
  }
`;

export const LoseButtonWrapper = styled.div`
  width: 100%;
  margin-top: 15px;
  display: flex;
  justify-content: center;

  ${DESKTOP_MEDIA_QUERY} {
    margin-top: 40px;
  }
`;

export const LoseButton = styled.div`
  width: 243px;
  height: 59px;
  line-height: 59px;
  border-radius: 45px;
  background-color: #fff;
  border: 2px solid #0000ff;
  font-size: 31px;
  font-weight: 700;
  color: #0000ff;
  text-align: center;
  text-transform: uppercase;

  ${DESKTOP_MEDIA_QUERY} {
    width: 370px;
    height: 90px;
    line-height: 90px;
    font-size: 50px;
    cursor: pointer;
  }
`;
